export enum SmsMessageRecipientDeliveryStatusCode {
	ACCEPTED_1 = 1,
	SCHEDULED_2 = 2,
	QUEUED_1000 = 1000,
	SENT_TO_GATEWAY_1001 = 1001,
	DELIVERED_2000 = 2000,
	ACCOUNT_VALIDATION_ERROR_3000 = 3000,
	CONFIGURATION_ERROR_3001 = 3001,
	INVALID_SENDER_3002 = 3002,
	SOURCE_TYPE_NOT_SUPPORTED_3003 = 3003,
	INVALID_RECIPIENT_3004 = 3004,
	DESTINATION_TYPE_NOT_SUPPORTED_3005 = 3005,
	ENCODING_NOT_SUPPORTED_3006 = 3006,
	INVALID_MESSAGE_CONTENT_3007 = 3007,
	INVALID_USER_DATA_HEADER_3008 = 3008,
	MAXIMUM_THROTTLING_EXCEEDED_3009 = 3009,
	VALIDATION_3010 = 3010,
	QUOTA_3011 = 3011,
	COUNTRY_BLOCKED_3013 = 3013,
	GENERIC_ERROR_4000 = 4000,
	TEMPORARY_ROUTING_ERROR_4001 = 4001,
	PERMANENT_ROUTING_ERROR_4002 = 4002,
	PHONE_NUMBER_BLOCKED_4003 = 4003,
	RECIPIENT_TEMPORARILY_BARRED_4004 = 4004,
	SERVICE_PROVIDER_ERROR_4005 = 4005,
	OPERATION_BLOCKED_4006 = 4006,
	NOT_DELIVERED_4007 = 4007,
	EXPIRED_4008 = 4008,
	TIMEOUT_4009 = 4009,
	DELIVERY_REPORT_NOT_SUPPORTED_4010 = 4010,
	DELETED_BY_OPERATOR_4011 = 4011,
	RETRIED_5000 = 5000,
}

export const SmsMessageRecipientDeliveryStatusGroups = {
	processing: [
		SmsMessageRecipientDeliveryStatusCode.ACCEPTED_1,
		SmsMessageRecipientDeliveryStatusCode.SCHEDULED_2,
		SmsMessageRecipientDeliveryStatusCode.QUEUED_1000,
		SmsMessageRecipientDeliveryStatusCode.SENT_TO_GATEWAY_1001,
		SmsMessageRecipientDeliveryStatusCode.RETRIED_5000,
	],
	delivered: [SmsMessageRecipientDeliveryStatusCode.DELIVERED_2000],
	failed: [
		SmsMessageRecipientDeliveryStatusCode.ACCOUNT_VALIDATION_ERROR_3000,
		SmsMessageRecipientDeliveryStatusCode.CONFIGURATION_ERROR_3001,
		SmsMessageRecipientDeliveryStatusCode.INVALID_SENDER_3002,
		SmsMessageRecipientDeliveryStatusCode.SOURCE_TYPE_NOT_SUPPORTED_3003,
		SmsMessageRecipientDeliveryStatusCode.INVALID_RECIPIENT_3004,
		SmsMessageRecipientDeliveryStatusCode.DESTINATION_TYPE_NOT_SUPPORTED_3005,
		SmsMessageRecipientDeliveryStatusCode.ENCODING_NOT_SUPPORTED_3006,
		SmsMessageRecipientDeliveryStatusCode.INVALID_MESSAGE_CONTENT_3007,
		SmsMessageRecipientDeliveryStatusCode.INVALID_USER_DATA_HEADER_3008,
		SmsMessageRecipientDeliveryStatusCode.MAXIMUM_THROTTLING_EXCEEDED_3009,
		SmsMessageRecipientDeliveryStatusCode.VALIDATION_3010,
		SmsMessageRecipientDeliveryStatusCode.QUOTA_3011,
		SmsMessageRecipientDeliveryStatusCode.COUNTRY_BLOCKED_3013,
		SmsMessageRecipientDeliveryStatusCode.GENERIC_ERROR_4000,
		SmsMessageRecipientDeliveryStatusCode.TEMPORARY_ROUTING_ERROR_4001,
		SmsMessageRecipientDeliveryStatusCode.PERMANENT_ROUTING_ERROR_4002,
		SmsMessageRecipientDeliveryStatusCode.PHONE_NUMBER_BLOCKED_4003,
		SmsMessageRecipientDeliveryStatusCode.RECIPIENT_TEMPORARILY_BARRED_4004,
		SmsMessageRecipientDeliveryStatusCode.SERVICE_PROVIDER_ERROR_4005,
		SmsMessageRecipientDeliveryStatusCode.OPERATION_BLOCKED_4006,
		SmsMessageRecipientDeliveryStatusCode.NOT_DELIVERED_4007,
		SmsMessageRecipientDeliveryStatusCode.EXPIRED_4008,
		SmsMessageRecipientDeliveryStatusCode.TIMEOUT_4009,
		SmsMessageRecipientDeliveryStatusCode.DELIVERY_REPORT_NOT_SUPPORTED_4010,
		SmsMessageRecipientDeliveryStatusCode.DELETED_BY_OPERATOR_4011,
	],
};
